import AnnotationFontSize from 'models/api/statement-annotations-fontsize-model';
import { handleActions } from 'redux-actions';
import { setStatementAnnotationsFontSize } from 'store/actions/statement-summary/statement-annotations-fontsize-actions';
import { clearSelectedStatement } from 'store/actions/selected-statement-actions';

export default handleActions(
  {
    [setStatementAnnotationsFontSize]: (annotationFontSize, { payload }) => {
      return annotationFontSize.setAnnotationFontSize(payload);
    },
    [clearSelectedStatement]: () => {
      return new AnnotationFontSize();
    },
  },
  new AnnotationFontSize(),
);
